import { render, staticRenderFns } from "./VirtualAccountModal.vue?vue&type=template&id=1cb77f95&scoped=true"
import script from "./VirtualAccountModal.vue?vue&type=script&lang=js"
export * from "./VirtualAccountModal.vue?vue&type=script&lang=js"
import style0 from "./VirtualAccountModal.vue?vue&type=style&index=0&id=1cb77f95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb77f95",
  null
  
)

export default component.exports